/** @format */

import React, { useEffect } from "react";

export const MS_SSO_MESSAGE_SOURCE = "ms-sso-callback";

const MicrosoftSsoCallback = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const message = {
      source: MS_SSO_MESSAGE_SOURCE,
      code: params.get("code"),
      state: params.get("state"),
      error: params.get("error"),
      errorDescription: params.get("error_description"),
    };

    if (window.opener) {
      window.opener.postMessage(message, window.location.origin);
      window.close();
    }
  }, []);

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}>
      <p>Signing you in with Microsoft…</p>
    </div>
  );
};

export default MicrosoftSsoCallback;
